import { store } from '../../redux/store';
import ApiBase from 'services/base/apiBase';
import { SaveCandidates } from '../../redux/slices/candidates';
import { ICompany } from 'core/interface/companies';
import { SaveCompanies, SavePublicCompanies } from '../../redux/slices/company';

export class CompanyService {
  private static readonly apiURL = new ApiBase<ICompany>();

  public static async getCompanies(
    candidate_id: string
  ): Promise<ICompany | void> {
    const { dispatch } = store;
    try {
      const res = await this.apiURL.getAsync(`/companies/${candidate_id}/`);
      dispatch(SaveCompanies(res));
      return res;
    } catch (error) {
      console.error('Error fetching companies:', error);
    }
  }

  public static async updateCompanies(
    body: object,
    candidate_id: string
  ): Promise<ICompany | null> {
    const { dispatch } = store;
    try {
      const res = await this.apiURL.updateAsync(
        `/companies/${candidate_id}/`,
        body
      );
      dispatch(SaveCompanies(res));
      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  // get public companies, to be updated once API is ready
  public static async getPublicCompanies(params?: {
    limit?: number;
    offset?: number;
    industry?: string;
    location_id?: number;
    company_size?: string;
  }): Promise<ICompany | void> {
    const { dispatch } = store;
    try {
      const queryParams = new URLSearchParams();
      if (params?.limit) queryParams.append('limit', params.limit.toString());
      if (params?.offset)
        queryParams.append('offset', params.offset.toString());
      if (params?.industry && params.industry !== '')
        queryParams.append('industries', params.industry);
      if (params?.location_id && params.location_id !== 0)
        queryParams.append('locations', params.location_id.toString());
      if (params?.company_size && params.company_size !== '')
        queryParams.append('sizes', params.company_size);

      const queryString = queryParams.toString();
      const url = `/companies/${queryString ? `?${queryString}` : ''}`;

      const res = await this.apiURL.getAsync(url);
      dispatch(SavePublicCompanies(res));
      return res;
    } catch (error) {
      console.error('Error fetching public companies:', error);
    }
  }
}
